import axios from 'axios';
import { get } from 'lodash';

export const getApi = () => {
  axios.defaults.baseURL =
    process.env.NODE_ENV === 'development'
      ? 'http://localhost:3001/api'
      : 'https://mini-dsp-online.herokuapp.com/api';
  axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
  const axiosInstance = axios.create();
  console.log(
    '🚀 ~ file: api.js ~ line 6 ~ getApi ~ axios.defaults.baseURL',
    axios.defaults.baseURL
  );

  axiosInstance.interceptors.response.use(
    response => response,
    error => {
      return Promise.reject({
        data: get(error, 'response.data'),
        status: get(error, 'response.status')
      });
    }
  );

  return axiosInstance;
};
